export const environment = {
  production: false,
  apiBaseUrl: 'https://gateway.dev.transflo.com/api/wfstudio/definition',
  portalSiteUrl: 'https://portal.dev.transflo.com/',
  portalApiUrl: 'https://gateway.dev.transflo.com/portal/graphql',
};
